export default __webpack_public_path__ + "static/media/hotel3.08274fd7.jpg";